var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'popup-overlay',
    { 'on': _vm.on }
],on:{"click":function($event){return _vm.$emit('closePopup')}}})}
var staticRenderFns = []

export { render, staticRenderFns }